import { render, staticRenderFns } from "./changeSubjectDialog.vue?vue&type=template&id=79077d82&scoped=true"
import script from "./changeSubjectDialog.vue?vue&type=script&lang=js"
export * from "./changeSubjectDialog.vue?vue&type=script&lang=js"
import style0 from "./changeSubjectDialog.vue?vue&type=style&index=0&id=79077d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79077d82",
  null
  
)

export default component.exports